<script>
import vSelect from 'vue-select'
import Vue from "vue";
import axios from "axios";
import { debounce } from "lodash";

Vue.component('v-select', vSelect)

export default {
    name: "SelectClient",
    props: {
        value: { // v-model dans Vue 2 = prop "value"
            type: String,
            default: null
        }
    },
    data() {
        return {
            list_client: []
        };
    },
    methods: {
        fetchClientList(recherche) {
            const formmulaire = new FormData();
            formmulaire.append("recherche", recherche);

            axios.post(this.BASE_URL + "/client/fetch", formmulaire)
                .then((response) => {
                    this.list_client = response.data;
                })
                .catch((err) => console.error(err));
        },

        onSearchClient: debounce(function (query) {
            this.fetchClientList(query);
        }, 400),
    },
    mounted() {
        this.fetchClientList('');
    }
}
</script>

<template>
    <div>
        <v-select
            id="nom_client"
            :options="list_client"
            :reduce="m => m.nom_client"
            label="nom_client"
            :value="value"
            @input="$emit('input', $event)"
            @search="onSearchClient"
            placeholder="Choisissez un client"
            style="width: 350px"
        />
    </div>
</template>
